import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var AvatarB2B = function AvatarB2B(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AvatarB2B_svg__AvatarB2B_svg__clip0_18154_91332)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#AvatarB2B_svg__AvatarB2B_svg__paint0_linear_18154_91332)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 21.834c0-2.334 4.666-3.617 7-3.617 2.334 0 7 1.283 7 3.617V23H9v-1.166zM19.5 12.5c0 1.937-1.564 3.5-3.5 3.5a3.495 3.495 0 01-3.5-3.5c0-1.937 1.563-3.5 3.5-3.5 1.936 0 3.5 1.563 3.5 3.5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AvatarB2B_svg__AvatarB2B_svg__paint0_linear_18154_91332",
    x1: 0,
    y1: 32,
    x2: 37.994,
    y2: 18.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89ABFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AvatarB2B_svg__AvatarB2B_svg__clip0_18154_91332"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  }))));
};
export default AvatarB2B;